import { UserAvatarGroup } from '@/components/UserAvatarGroup/UserAvatarGroup';
import Box from '@/design_system/Box';
import { RequestWithRelationsFromRequestsList } from '@/models/request';

export const CollaboratorsCell = ({
  collaborators,
  variant,
}: {
  collaborators: RequestWithRelationsFromRequestsList['collaborators'];
  variant: 'card' | 'row';
}) => {
  if (!collaborators?.length) {
    return;
  }

  if (variant === 'row') {
    return <UserAvatarGroup users={collaborators} />;
  }

  return (
    <Box padding="0.25rem 0.5rem" style={{ flex: 'none' }}>
      <UserAvatarGroup users={collaborators} size="xx-small" />
    </Box>
  );
};
